<script>
import { h } from 'vue';
import percentage from '~/filters/percentage';

export default {
  name: 'ReportTableProgressBar',
  props: {
    tracked: {
      required: true,
    },
    total: {
      required: true,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  render() {
    const tracked = this.tracked;
    const total = this.total;
    const progressBarClass = this.success ? 'progress-bar-success' : 'progress-bar-info';
    const width = percentage(tracked, total);

    return h('div', { class: 'progress' }, [
      h('div', {
        class: `progress-bar ${progressBarClass}`,
        style: { width },
        role: 'progressbar',
      }),
    ]);
  },
};
</script>
